import { ShapeSize } from './types';

export const shapeSizeMap: Record<ShapeSize, number> = {
  xsmall: 2,
  small: 5,
  medium: 8,
  large: 12,
  xlarge: 16,
  xxlarge: 20,
};
